export const formatExpiry = (value: string): string => {
  let v = value.replace(/\D/g, '').slice(0, 4);

  if (v.length === 1) {
    if (Number(v) > 1) {
      v = `0${v}`;
    }
  }

  if (v.length >= 2) {
    const month = v.slice(0, 2);

    if (Number(month) > 12) {
      v = `12${v.slice(2)}`;
    } else if (Number(month) === 0 && v.length === 2) {
      return v;
    }
  }

  if (v.length > 2) {
    return `${v.slice(0, 2)}/${v.slice(2)}`;
  }

  return v;
};
